import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "p-3" }
const _hoisted_6 = { class: "d-flex justify-content-end" }

import ClassificationInformationsSelect from "@/components/ClassificationInformationsSelect.vue";
import MunicipalitySelect from "@/components/MunicipalitySelect.vue";
import { useValidateProps } from "@/composables/fields";
import { isMobileReactive } from "@/helpers";
import { dbEnums } from "@/types/enums/dbEnums";
import { DraftImmigrantDto } from "@api/draft-immigrant-dto";
import { ResidencePermitDto } from "@api/residence-permit-dto";
import { PropType, computed } from "vue";
import { PersonFieldCategoryMap } from "..";
import Field from "../../Field.vue";
import FormFields from "../../FormFields.vue";
import FormSection from "../../FormSection.vue";
import FormSectionHeader from "../../FormSectionHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImmigrantFormIntegrationFields',
  props: {
	fieldsMap: {
		type: Object as PropType<PersonFieldCategoryMap>,
		required: true,
	},
	modelValue: {
		type: Object as PropType<DraftImmigrantDto>,
		required: true,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const fields = dbEnums.PersonFields;

const formDataComputed = computed({
	get() {
		return props.modelValue;
	},
	set(v) {
		emit("update:modelValue", v);
	},
});

const addResidencePermit = () => {
	if (!formDataComputed.value.residencePermits) {
		formDataComputed.value.residencePermits = [];
	}

	formDataComputed.value.residencePermits.push({
		id: 0,
		issueDate: null,
		endDate: null,
		draftImmigrantId: 0,
		draftImmigrant: null,
		residencePermitOtherBasis: "",
		residencePermitBasisId: null,
		residencePermitBasis: null,
		typeId: null,
		type: null,
	} as unknown as ResidencePermitDto);
};

const removeResidencePermit = (index: number) => {
	if (formDataComputed.value.residencePermits) {
		formDataComputed.value.residencePermits?.splice(index, 1);
	}
};

const validateProps = useValidateProps();

return (_ctx: any,_cache: any) => {
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoDatePicker = _resolveComponent("HakoDatePicker")!
  const _component_HakoButton = _resolveComponent("HakoButton")!
  const _component_HakoTextArea = _resolveComponent("HakoTextArea")!

  return (_openBlock(), _createBlock(FormSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormSectionHeader, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("immigrantForm.sectionHeaders.immigrationInfo")), 1)
            ]),
            _: 1
          })
        ]),
        (__props.fieldsMap.ImmigrantIntegrationInfo)
          ? (_openBlock(), _createBlock(FormFields, {
              key: 0,
              fields: __props.fieldsMap.ImmigrantIntegrationInfo.fields
            }, {
              [_unref(fields).ImmigrantFirstResidenceMunicipality]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.firstResidenceMunicipalityId"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'd-flex gap-3 align-items-center': !_unref(isMobileReactive) })
                    }, [
                      _createVNode(MunicipalitySelect, {
                        valueSingle: formDataComputed.value.firstResidenceMunicipality,
                        "onUpdate:valueSingle": _cache[0] || (_cache[0] = ($event: any) => ((formDataComputed.value.firstResidenceMunicipality) = $event)),
                        valueSingleId: formDataComputed.value.firstResidenceMunicipalityId,
                        "onUpdate:valueSingleId": _cache[1] || (_cache[1] = ($event: any) => ((formDataComputed.value.firstResidenceMunicipalityId) = $event)),
                        ajax: "",
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                        style: {"max-width":"250px"}
                      }, null, 8, ["valueSingle", "valueSingleId", "isInvalid", "onBlur"]),
                      _createVNode(_component_HakoBsIcon, {
                        class: _normalizeClass(["duration-arrow", { 'mx-3': _unref(isMobileReactive) }]),
                        size: 150,
                        icon: "arrow-right"
                      }, null, 8, ["class"]),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("generic.recordDate")), 1),
                      _createVNode(_component_HakoDatePicker, {
                        modelValue: formDataComputed.value.firstResidenceMunicipalityRecordDate,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataComputed.value.firstResidenceMunicipalityRecordDate) = $event)),
                        allowEmpty: "",
                        id: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                        placeholder: _ctx.$t('generic.datePlaceholder'),
                        style: {"max-width":"250px"}
                      }, null, 8, ["modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantCalculatedCompensation]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.calculatedCompensationId"
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'd-flex gap-3 align-items-center': !_unref(isMobileReactive) })
                    }, [
                      _createVNode(ClassificationInformationsSelect, {
                        valueSingle: formDataComputed.value.calculatedCompensation,
                        "onUpdate:valueSingle": _cache[3] || (_cache[3] = ($event: any) => ((formDataComputed.value.calculatedCompensation) = $event)),
                        valueSingleId: formDataComputed.value.calculatedCompensationId,
                        "onUpdate:valueSingleId": _cache[4] || (_cache[4] = ($event: any) => ((formDataComputed.value.calculatedCompensationId) = $event)),
                        infoTable: "CalculatedCompensations",
                        translationsTable: "CalculatedCompensationTranslations",
                        translationProperty: "name",
                        ajax: false,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                        style: {"max-width":"750px"}
                      }, null, 8, ["valueSingle", "valueSingleId", "isInvalid", "onBlur"]),
                      _createVNode(_component_HakoBsIcon, {
                        class: _normalizeClass(["duration-arrow", { 'mx-3': _unref(isMobileReactive) }]),
                        size: 150,
                        icon: "arrow-right"
                      }, null, 8, ["class"]),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("generic.endingDate")), 1),
                      _createVNode(_component_HakoDatePicker, {
                        modelValue: formDataComputed.value.calculatedCompensationEndDate,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataComputed.value.calculatedCompensationEndDate) = $event)),
                        allowEmpty: "",
                        id: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                        placeholder: _ctx.$t('generic.datePlaceholder'),
                        style: {"max-width":"250px"}
                      }, null, 8, ["modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["field"])
              ]),
              [_unref(fields).ImmigrantMunicipalityDecisionDate]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftImmigrantData.municipalitySpotDecisionDate"
                  }, {
                    default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                      _createVNode(_component_HakoDatePicker, {
                        modelValue: formDataComputed.value.municipalitySpotDecisionDate,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataComputed.value.municipalitySpotDecisionDate) = $event)),
                        allowEmpty: "",
                        id: elementId,
                        isInvalid: isInvalid,
                        onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                        placeholder: _ctx.$t('generic.datePlaceholder'),
                        style: {"max-width":"250px"}
                      }, null, 8, ["modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).ImmigrantResidencePermits]: _withCtx(({ field }) => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(Field, {
                    field: field,
                    propertyPath: "draftImmigrantData.residencePermits"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formDataComputed.value.residencePermits, (permit, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "card mb-2",
                          key: i
                        }, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(Field, {
                              field: field,
                              propertyPath: `draftImmigrantData.residencePermits[${i}].issueDate`,
                              label: _ctx.$t('immigrantForm.residencePermitDate')
                            }, {
                              default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                                _createVNode(_component_HakoDatePicker, {
                                  modelValue: permit.issueDate,
                                  "onUpdate:modelValue": ($event: any) => ((permit.issueDate) = $event),
                                  allowEmpty: "",
                                  id: elementId,
                                  isInvalid: isInvalid,
                                  onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                  placeholder: _ctx.$t('generic.datePlaceholder'),
                                  style: {"max-width":"250px"}
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                              ]),
                              _: 2
                            }, 1032, ["field", "propertyPath", "label"]),
                            _createVNode(Field, {
                              field: field,
                              propertyPath: `draftImmigrantData.residencePermits[${i}].typeId`,
                              label: _ctx.$t('immigrantForm.residencePermitType')
                            }, {
                              default: _withCtx(({ propertyPaths, isInvalid }) => [
                                _createVNode(ClassificationInformationsSelect, {
                                  valueSingle: permit.type,
                                  "onUpdate:valueSingle": ($event: any) => ((permit.type) = $event),
                                  valueSingleId: permit.typeId,
                                  "onUpdate:valueSingleId": ($event: any) => ((permit.typeId) = $event),
                                  infoTable: "ResidencePermitOptions",
                                  translationsTable: "ResidencePermitOptionTranslations",
                                  translationProperty: "name",
                                  ajax: false,
                                  isInvalid: isInvalid,
                                  onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                  style: {"max-width":"500px"}
                                }, null, 8, ["valueSingle", "onUpdate:valueSingle", "valueSingleId", "onUpdate:valueSingleId", "isInvalid", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["field", "propertyPath", "label"]),
                            _createVNode(Field, {
                              field: field,
                              propertyPath: `draftImmigrantData.residencePermits[${i}].residencePermitBasisId`,
                              label: _ctx.$t('immigrantForm.residencePermitBasis')
                            }, {
                              default: _withCtx(({ propertyPaths, isInvalid }) => [
                                _createVNode(ClassificationInformationsSelect, {
                                  valueSingle: permit.residencePermitBasis,
                                  "onUpdate:valueSingle": ($event: any) => ((permit.residencePermitBasis) = $event),
                                  valueSingleId: permit.residencePermitBasisId,
                                  "onUpdate:valueSingleId": ($event: any) => ((permit.residencePermitBasisId) = $event),
                                  infoTable: "ResidencePermitBasises",
                                  translationsTable: "ResidencePermitBasisTranslations",
                                  translationProperty: "name",
                                  ajax: false,
                                  isInvalid: isInvalid,
                                  onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                                  style: {"max-width":"500px"}
                                }, null, 8, ["valueSingle", "onUpdate:valueSingle", "valueSingleId", "onUpdate:valueSingleId", "isInvalid", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["field", "propertyPath", "label"]),
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_HakoButton, {
                                theme: "danger",
                                onClick: () => removeResidencePermit(i)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("immigrantForm.removeResidencePermit")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ])
                        ]))
                      }), 128)),
                      _createVNode(_component_HakoButton, { onClick: addResidencePermit }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("immigrantForm.addResidencePermit")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["field"])
                ])
              ]),
              [_unref(fields).ImmigrantTravelDocuments]: _withCtx(({ field }) => [
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.travelDocumentTypeId",
                  label: _ctx.$t('immigrantForm.travelDocumentType')
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid }) => [
                    _createVNode(ClassificationInformationsSelect, {
                      valueSingle: formDataComputed.value.travelDocumentType,
                      "onUpdate:valueSingle": _cache[7] || (_cache[7] = ($event: any) => ((formDataComputed.value.travelDocumentType) = $event)),
                      valueSingleId: formDataComputed.value.travelDocumentTypeId,
                      "onUpdate:valueSingleId": _cache[8] || (_cache[8] = ($event: any) => ((formDataComputed.value.travelDocumentTypeId) = $event)),
                      infoTable: "TravelDocumentTypes",
                      translationsTable: "TravelDocumentTypeTranslations",
                      translationProperty: "name",
                      ajax: false,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      style: {"max-width":"500px"}
                    }, null, 8, ["valueSingle", "valueSingleId", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field", "label"]),
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.travelDocumentStartDate",
                  label: _ctx.$t('immigrantForm.travelDocumentStartDate')
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoDatePicker, {
                      modelValue: formDataComputed.value.travelDocumentStartDate,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formDataComputed.value.travelDocumentStartDate) = $event)),
                      allowEmpty: "",
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      placeholder: _ctx.$t('generic.datePlaceholder'),
                      style: {"max-width":"250px"}
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                  ]),
                  _: 2
                }, 1032, ["field", "label"]),
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.travelDocumentEndDate",
                  label: _ctx.$t('immigrantForm.travelDocumentEndDate')
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoDatePicker, {
                      modelValue: formDataComputed.value.travelDocumentEndDate,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formDataComputed.value.travelDocumentEndDate) = $event)),
                      allowEmpty: "",
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths)),
                      placeholder: _ctx.$t('generic.datePlaceholder'),
                      style: {"max-width":"250px"}
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur", "placeholder"])
                  ]),
                  _: 2
                }, 1032, ["field", "label"]),
                _createVNode(Field, {
                  field: field,
                  propertyPath: "draftImmigrantData.travelDocumentDescription",
                  label: _ctx.$t('immigrantForm.travelDocumentDescription')
                }, {
                  default: _withCtx(({ propertyPaths, isInvalid, elementId }) => [
                    _createVNode(_component_HakoTextArea, {
                      modelValue: formDataComputed.value.travelDocumentDescription,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formDataComputed.value.travelDocumentDescription) = $event)),
                      id: elementId,
                      isInvalid: isInvalid,
                      onBlur: ($event: any) => (_unref(validateProps)(propertyPaths))
                    }, null, 8, ["modelValue", "id", "isInvalid", "onBlur"])
                  ]),
                  _: 2
                }, 1032, ["field", "label"])
              ]),
              _: 2
            }, 1032, ["fields"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})